//该文件专门用于创建整个应用的路由器

import VueRouter from "vue-router"
import homepage from "../pages/homepage"
import functions from "../pages/functions"

/* 课程页面 */
import programmes from "../pages/programmes/programmes.vue"
import question from "../pages/question"
import Sweepstakes from "../pages/Sweepstakes"
import Chat from "../pages/Chat" /* 聊天 */
import Login from "../pages/Login" /* 登录页面 */
import Error from "../pages/error/Error"
/* 课程视频播放页面 */
import Videoing from '../pages/programmes/Videoing.vue'

/* 个人信息 和 管理 */
import MyInfomation from "../pages/user/UserInfo/MyInfomation"
import Info from '../pages/user/UserInfo/Info'
import CompeteExpence from '../pages/user/UserInfo/CompeteExpence'
import Study from '../pages/user/UserInfo/Study.vue'
import Manage from '../pages/user/manage/Manage.vue'
/* 管理页面的题目修改 */
import QuestionTemplate from '../pages/user/manage/AllQuestion/QuestionTemplate.vue'
import QuestionExample from '../pages/user/manage/AllQuestion/QuestionExample.vue'
import QuestionVideo from '../pages/user/manage/AllQuestion/QuestionVideo.vue'
/* 管理页面的课程修改 */
import CourseTemplate from '../pages/user/manage/Course/CourseTemplate.vue'
/* 管理页面的竞赛修改 */
import CompeteTemplate from '../pages/user/manage/Compete/CompeteTemplate.vue'
import CompeteProblemTemplate from '../pages/user/manage/Compete/CompeteProblemTemplate.vue'

/* 题目 */
import Problem from '../pages/xiti/Problem'
import Vedio from '../pages/xiti/AboutProblem/Vedio.vue'
import Solve from '../pages/xiti/AboutProblem/Solve.vue'
import Record from '../pages/xiti/AboutProblem/Record.vue'
import Content from '../pages/xiti/AboutProblem/Content.vue'

/* 比赛页面 */
import ContestPage from '../pages/TheCompete/ContestPage'
import Submit from '../pages/TheCompete/submit/Submit.vue'
import Rank from '../pages/TheCompete/rank/Rank.vue'
import CompeteProblem from '../pages/TheCompete/problem/CompeteProblem.vue'
import Statement from '../pages/TheCompete/statement/Statement.vue'
import Notes from '../pages/TheCompete/notes/Notes.vue'

import CompeteContentProblem from '../pages/TheCompete/problem/content/CompeteContentProblem.vue'
import SubmitCode from '../pages/TheCompete/problem/content/SubmitCode.vue'
import SubmitRecord from '../pages/TheCompete/problem/content/SubmitRecord.vue'

/* 订单页面 */
import OrderSystem from '../pages/OrderSystem/OrderSystem'
import Consume from '../pages/OrderSystem/Consume'
import FinishConsume from '../pages/OrderSystem/FinishConsume'
import BuySystem from '../pages/OrderSystem/BuySystem'

/* 题解 */
import MakeNotes from '../pages/xiti/AboutProblem/notes/MakeNotes.vue'
import ShowNotes from '../pages/xiti/AboutProblem/notes/ShowNotes.vue'
import UpdateNotes from '../pages/xiti/AboutProblem/notes/UpdateNotes.vue'

import store from "@/store"

//创建并默认暴露一个路由器
const router =  new VueRouter({
   mode: 'history',
   routes:[
      /* 路由重定向 是的首页变成默认进来就看到的页面 */
      {
         path:'/',
         redirect:'/function',
         meta: {
            check: false
         }
      },
      { // 讨论区路由
         path:'/homepage',
         name:'homepage',
         component:homepage,
         meta: {
            check: false
         },
         children: [
            {
               path:'chat',
               component:Chat
            }
         ]
      },
      { // 登录路由
         path:'/login',
         name:'login',
         component:Login,
         meta: {
            check: false
         },
      },
      { // 首页路由
         path:'/function',
         name:'function',
         component:functions,
         meta: {
            check: false
         },
      },
      { // 课程路由
         path:'/programmes/:id',
         name:'programmes',
         component:programmes,
         meta: {
            check: true
         },
      },
      { // 题库路由
         path:'/question',
         name:'question',
         component:question,
         meta: {
            check: false
         },
      },
      { // 竞赛路由
         path:'/sweepstakes',
         name:'sweepstakes',
         component:Sweepstakes,
         meta: {
            check: false
         },
      },
      {
         path: "/404/",
         name: "404",
         component: Error,
         meta: {
            check: false
         },
      },
      { //它用的是编程式导航 具体的内容是写题解页面路由
         path: "/MakeNotes/:id",
         name:'MakeNotes',
         component:MakeNotes,
         meta: {
            check: true
         },
      },
      { //它用的是编程式导航 具体的内容是展示题解页面路由
         path: "/Problem/ShowNotes/:id",
         name:'ShowNotes',
         component:ShowNotes,
         meta: {
            check: true
         },
      },
      {
         path:'/Problem/UpdateNotes/:id',
         name:'UpdateNotes',
         component:UpdateNotes,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 具体的内容是题目页面路由
         path:'/Problem/',
         component:Problem,
         children:[
            {
               path:'Vedio/:id',
               name:'problemName',
               component:Vedio,
               meta: {
                  check: true
               },
            },
            {
               path:'Content/:id',
               name:'problemContent',
               component:Content,
               meta: {
                  check: false
               },
            },
            {
               path:'Record/:id',
               name:'problemRecord',
               component:Record,
               meta: {
                  check: true
               },
            },
            {
               path:'Solve/:id',
               name:'problemSolve',
               component:Solve,
               meta: {
                  check: false
               },
            },
         ]
      },
      {//它用的是编程式导航 个人信息路由
         path:'/MyInfomation',
         component:MyInfomation,
         redirect:'/MyInfomation/info',
         children:[
            {
               path:'info',
               component:Info,
               meta: {
                  check: true
               },
            },
            {
               path:'competeexpence',
               component:CompeteExpence,
               meta: {
                  check: true
               },
            },
            {
               path:'manage',
               component:Manage,
               meta: {
                  check: true
               },
            },
            {
               path:'study',
               component:Study,
               meta: {
                  check: true
               },
            }
         ]
      },
      {//它用的是编程式导航 比赛页面路由
         path:'/contestPage',
         component:ContestPage,
         //redirect:'/contestPage/competeProblem',
         children:[
            {
               path:'competeProblem/:id',
               name:'competeProblem',
               component:CompeteProblem,
               meta: {
                  check: true
               },
            },
            {
               path:'rank/:id',
               component:Rank,
               meta: {
                  check: true
               },
            },
            {
               path:'notes/:id',
               component:Notes,
               meta: {
                  check: true
               },
            },
            {
               path:'statement/:id',
               component:Statement,
               meta: {
                  check: true
               },
            },
            {
               path:'submit/:id',
               component:Submit,meta: {
                  check: true
               },
            }
         ]
      },
      {//它用的是编程式导航 竞赛试题页面路由
         path: '/compete/content/problem/',
         name:'CompeteContentProblem',
         component: CompeteContentProblem,
         children:[
            {
               path:'SubmitCode/:competeId/:pbid/:id',
               component:SubmitCode,
               meta: {
                  check: true
               },
            },
            {
               path:'SubmitRecord/:competeId/:pbid/:id',
               component:SubmitRecord,
               meta: {
                  check: true
               },
            }
         ]
      },
      {//它用的是编程式导航 题目视频路由
         path:'/programmes/videoing/:id/:catalogId/:Vid',
         name:'LessonVideos',
         component:Videoing,
         meta: {
            check: true
         },
      },
      
      /* 管理修改页面路由 */
      {//它用的是编程式导航 题目修改路由
         path:'/AboutQuestion',
         component:QuestionTemplate,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 样例修改路由
         path:'/AboutExample',
         component:QuestionExample,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 题目题解视频修改路由
         path:'/AboutQuestionVideo',
         component:QuestionVideo,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 课程修改路由
         path:'/AboutCourse',
         component:CourseTemplate,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 竞赛修改路由
         path:'/AboutCompete',
         component:CompeteTemplate,
         meta: {
            check: true
         },
      },
      {//它用的是编程式导航 竞赛修改试题路由
         path:'/AboutCompeteProblem',
         component:CompeteProblemTemplate,
         meta: {
            check: true
         },
      },

      {// 订单路由
         path:'/order',
         component:OrderSystem,
         // redirect:'/order/buy/:id',
         children:[
            {
               path:'buy/:id',
               name:'buy',
               component:BuySystem,
               meta: {
                  check: true
               },
            },
            {
               path:'consume/:id',
               name:'consume',
               component:Consume,
               meta: {
                  check: true
               },
            },
            {
               path:'finsh',
               component:FinishConsume,
               meta: {
                  check: true
               },
            },
         ]
      },
      {
         path: "/:catchAll(.*)",
         redirect: "/404/"
      },
   ]
});

//全局前置路由守卫---每次路由切换之前被调用 初始化的时候被调用
router.beforeEach((to, from, next) => {

   const jwt_token = localStorage.getItem("jwt_token")
   if (jwt_token) {    
      store.commit("updateToken", jwt_token)
      store.dispatch("getinfo", {
         success() {
            store.commit("updatePullingInfo", false)
         },
         error() {
            store.commit("updatePullingInfo", false)
         },
      })
   } else {
      store.commit("updatePullingInfo", false)

      console.log(to.path)
      console.log(from.path)
   }
   next()
})

// 全局后置路由守卫---初始化的时候调用 每次路由切换之后被调用
router.afterEach((to, from) => {
   const jwt_token = localStorage.getItem("jwt_token")

   if (to.meta.check && !jwt_token) {
      console.log("要登录")
      router.push({name: 'login'})
   } 
})

export default router